import { render, staticRenderFns } from "./CumulativeBarChartLegend.vue?vue&type=template&id=5370ebdc"
import script from "./CumulativeBarChartLegend.vue?vue&type=script&lang=js"
export * from "./CumulativeBarChartLegend.vue?vue&type=script&lang=js"
import style0 from "./CumulativeBarChartLegend.vue?vue&type=style&index=0&id=5370ebdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports